'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from '@api/user'
import { hospitalGet } from '@api/daOrder'
import store from "@utils/store/cookie"

const LOGIN_KEY = "login_status"

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    token: store.get(LOGIN_KEY) || null,
    userInfo: null,
    hospital: null
  },
  // getters 相当于 Store 的计算属性
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    hospital: state => state.hospital
  },
  // mutations 必须是同步函数
  mutations: {
    UPDATE_USERINFO (state, userInfo) {
      state.userInfo = userInfo || null
    },
    LOGIN(state, token, expiresTime) {
      state.token = token
      store.set(LOGIN_KEY, token, expiresTime)
    },
    LOGOUT(state) {
      state.token = undefined
      store.remove(LOGIN_KEY)
    },
    UPDATE_HOSPITAL(state, hospital) {
      state.hospital = hospital || null
    }
  },
  // actions 可以是异步函数
  actions: {
    USERINFO ({ commit }, force) {
      getUserInfo().then(res => {
        commit("UPDATE_USERINFO", res.data)
        // reslove(res.data)
      }).catch(err => {
        console.log(err)
      })
    },
    GET_HOSPITAL ({ commit }, hospitalId) {
      hospitalGet(hospitalId).then(res => {
        commit("UPDATE_HOSPITAL", res.data.hospital)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  modules: {
  }
})
